import { useNotifications } from '@sequencehq/core-components'
import { useMutation } from '@sequencehq/api/utils'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { logError } from '@sequencehq/utils'
import { getApiErrorMessage } from 'Cube/utils/getApiErrorMessage'

export const useCreateAnrokMapping = () => {
  const { displayNotification } = useNotifications()

  const { mutateAsync: postTaxCategoryAnrokMapping } = useMutation(
    dashboardv99990101Client.postTaxCategoryAnrokMapping
  )

  return async ({
    taxCategoryId,
    taxCategoryName,
    anrokTaxCategoryId,
    anrokTaxCategoryType,
    isDefault
  }: {
    taxCategoryId: string
    taxCategoryName: string
    anrokTaxCategoryId: string
    anrokTaxCategoryType: 'standard' | 'custom'
    isDefault: boolean
  }) => {
    try {
      await postTaxCategoryAnrokMapping({
        taxCategoryId,
        taxCategoryName,
        anrokTaxCategoryId,
        anrokTaxCategoryType,
        isDefault
      })

      displayNotification('Anrok tax code linked to category', {
        type: 'success'
      })
    } catch (error) {
      console.error('Failed to create Anrok mapping:', error)
      logError(error)

      const backendMessage = getApiErrorMessage(error, '')
      const errorMessage = backendMessage
        ? `Failed to link Anrok tax code: ${backendMessage}`
        : 'Failed to link Anrok tax code to category'

      displayNotification(errorMessage, {
        type: 'error'
      })
      throw error
    }
  }
}
